import React, { useState, useMemo } from "react";
import {
  Box,
  makeStyles,
  Paper,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import Logo from "../../assets/images/logo_transparent.png";
import {
  signInWithEmailAndPassword,
  signInWithGoogle,
} from "./components/Login-Common";
import TokenHelper from "../../helpers/TokenHelper";

export default function Login() {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [selectedQuickLogin, setSelectedQuickLogin] = useState("");

  const tokenHelper = new TokenHelper();

  // Parse quick login data from environment variable
  const quickLogins = useMemo(() => {
    const quickLoginValue = process.env.REACT_APP_QUICK_LOGIN;
    if (!quickLoginValue) {
      return [];
    }

    try {
      return quickLoginValue.split(",").map((login) => {
        const [username, password] = login.split("|");
        return { username: username.trim(), password: password.trim() };
      });
    } catch (error) {
      console.error("Error parsing REACT_APP_QUICK_LOGIN:", error);
      return [];
    }
  }, []);

  // Handle quick login selection
  const handleQuickLoginChange = (event) => {
    const selectedUsername = event.target.value;
    setSelectedQuickLogin(selectedUsername);
    
    const selectedLogin = quickLogins.find(
      (login) => login.username === selectedUsername
    );
    if (selectedLogin) {
      setUsername(selectedLogin.username);
      setPassword(selectedLogin.password);
    }
  };

  if (
    tokenHelper.doAuthTokensExist() &&
    window.location.href.includes("/login")
  ) {
    window.location.href = "/";
  }

  const signIn = (type) => {
    if (type === "Email") signInWithEmailAndPassword(username, password);
    else if (type === "Google") signInWithGoogle();
  };

  window.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      document.getElementById("signInWithEmailAndPasswordBtn").click();
    }
  });

  return (
    <Box className={classes.root}>
      <Paper className={classes.paper}>
        <Box className={classes.logoContainer}>
          <img
            src={Logo}
            alt="logo"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>
        <Box className={classes.inputControlContainer}>
          <TextField
            variant="filled"
            className={classes.inputControl}
            label="Username"
            onChange={(e) => {
              setUsername(e.target.value);
            }}
            value={username}
          />
          <TextField
            variant="filled"
            className={classes.inputControl}
            label="Password"
            type="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            value={password}
          />
        </Box>
        {quickLogins.length > 0 && (
          <Box className={classes.quickLoginContainer}>
            <FormControl
              variant="filled"
              className={classes.quickLoginSelect}
              fullWidth
            >
              <InputLabel>Quick Login</InputLabel>
              <Select
                value={selectedQuickLogin}
                onChange={handleQuickLoginChange}
                label="Quick Login"
              >
                {quickLogins.map((login, index) => (
                  <MenuItem key={index} value={login.username}>
                    {login.username}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        <Box className={classes.buttonContainer}>
          <Button
            id="signInWithEmailAndPasswordBtn"
            variant="contained"
            color="primary"
            className={classes.buttonControl}
            onClick={() => signIn("Email")}
          >
            Sign in with email
          </Button>
          {/*
          <Button
            variant="contained"
            color="primary"
            className={classes.buttonControl}
            onClick={() => signIn("Google")}
          >
            Sign in with Google
          </Button>
          */}
        </Box>
      </Paper>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    background: "#141A46",
    display: "flex",
    alignContent: "middle",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 450,
    textAlign: "center",
    justifyContent: "space-evenly",
    margin: "auto",
    borderRadius: 15,
    [theme.breakpoints.down("lg")]: {
      minHeight: "75vh",
    },
    [theme.breakpoints.only("xl")]: {
      minHeight: "60vh",
    },
  },
  logoContainer: {
    maxWidth: 300,
    marginLeft: "auto",
    marginRight: "auto",
  },
  inputControlContainer: {
    width: "75%",
    height: 200,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    marginLeft: "auto",
    marginRight: "auto",
  },
  quickLoginContainer: {
    width: "75%",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: theme.spacing(2),
  },
  quickLoginSelect: {
    minWidth: 200,
  },
  buttonContainer: {
    width: "80%",
    height: 110,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    marginLeft: "auto",
    marginRight: "auto",
  },
  inputControl: {},
  buttonControl: {
    height: 50,
    borderRadius: 10,
    letterSpacing: 1,
    fontSize: 12,
    fontWeight: "bold",
  },
}));
